import { render, staticRenderFns } from "./CategoryPermissionBulk.vue?vue&type=template&id=16b2b990&"
import script from "./CategoryPermissionBulk.vue?vue&type=script&lang=js&"
export * from "./CategoryPermissionBulk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports